const trimTag = (tag = '') => tag.toString().trim();

export const tagToSlug = (tag = '') =>
  trimTag(tag)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
